import { render, staticRenderFns } from "./Download.vue?vue&type=template&id=079fac2f&"
import script from "./Download.vue?vue&type=script&lang=ts&"
export * from "./Download.vue?vue&type=script&lang=ts&"
import style0 from "./Download.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports